import { toast } from 'react-hot-toast';

import { i18n, i18ToastNS } from '@shared/config/i18n';

import { TOAST_ICONS } from '../constants';
import { CustomToastContent } from '../ui';

// deduplication — repeated call with the same id is ignored until duration expires
const activeToasts = new Set();

/**
 * @param {string} type - one of TOAST_TYPES values
 * @param {string | { key: string, ns: string }} messageKey - plain string or i18n key
 * @param {{ duration?: number, position?: string, id?: string }} [options]
 *
 * @example
 * showCustomToast(TOAST_TYPES.SUCCESS, { key: Translation.LOGOUT_SUCCESS, ns: i18TranslationNS });
 * showCustomToast(TOAST_TYPES.ERROR, error?.data?.message ?? { key: Translation.HOME_AUTH_FAILED, ns: i18TranslationNS });
 */
export const showCustomToast = (type, messageKey, options = {}) => {
	const isString = typeof messageKey === 'string';
	const toastId = options.id ?? `${type}-${isString ? messageKey : messageKey.key}`;

	if (activeToasts.has(toastId)) return;

	activeToasts.add(toastId);

	const duration = options.duration ?? 5000;

	const icon = TOAST_ICONS[type];
	const message = isString ? messageKey : i18n.t(messageKey.key, { ns: messageKey.ns });
	const typeLabel = i18n.t(`typeLabel.${type}`, { ns: i18ToastNS });

	const id = toast.custom(
		() => <CustomToastContent icon={icon} message={message} type={type} typeLabel={typeLabel} />,
		{
			id: toastId,
			duration,
			...options,
		},
	);

	setTimeout(() => {
		activeToasts.delete(toastId);
	}, duration + 50);

	return id;
};
